import Item, { IComment } from './item'
import React, {
  SyntheticEvent,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

import { GlobalStoreContext } from '../../components/store'
import Header from './header'
import Loading from '../loading'
import fetch from 'lib/decorated-fetch'
import get from 'lodash/get'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import safeGet from '@arsenal/arsenal/modules/safeGet'
import xss from 'xss'
import Toast from 'Components/toast-messager'
import EventBus from 'lib/eventbus'
import getLinkHref from 'lib/get-link-href'
import Link from 'next/link'
import { ArticleCardContext } from 'Components/ugc/article-card'
import { ugcArticleContext } from 'Pages/ugc/article'
import Cookies from '@arsenal/arsenal/modules/Cookies'

const show_more_icon = require('static/show-more.png')

interface IProps {
  aid?: number
  gid: string
  author_id: number
  titleLeft?: string
  appName?: string
  count?: number
  type?: 'article' | 'koubei'
}

interface ICommentData {
  total_number: number
  data: IComment[]
  has_more: boolean
}

// 分页缓存数据

function Comment({
  aid = 1839,
  gid,
  appName = 'auto_web_pc',
  count = 10,
  titleLeft,
  type = 'article',
  author_id,
}: IProps) {
  const [dataList, setDataList] = useState<IComment[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(0)
  const [hasMoreComment, setHasMoreComment] = useState(true)
  const { state } = useContext(GlobalStoreContext)
  const userId = Number(get(state, 'userData.user_id'))
  const [commentCount, setCommentCount] = useState(0)
  let { updated_total_count, updateTotalCount } = useContext(ArticleCardContext)
  const { inheritNewCard } = useContext(ArticleCardContext)
  if (!updated_total_count || !updateTotalCount) {
    const {
      updated_total_count: updated_total_count_uac,
      updateTotalCount: updateTotalCount_uac,
    } = useContext(ugcArticleContext)
    updated_total_count = updated_total_count_uac
    updateTotalCount = updateTotalCount_uac
  }
  const href = getLinkHref(
    `/ugc/${type === 'koubei' ? 'koubei' : 'article'}/${gid}`
  )

  /* 获取评论列表 */
  function loadComment() {
    const params = {
      aid,
      app_name: appName,
      group_id: gid,
      item_id: gid,
      offset: currentPage * count,
      count,
    }
    setIsLoading(true)
    fetch(
      getUrl(
        `/motor/proxy/comment_list/article/v3/tab_comments/?${serializeObject(
          params
        )}`
      )
    )
      .then((res: ICommentData) => {
        const { total_number, data, has_more } = res
        setCommentCount(total_number)
        setDataList(dataList.concat(data))
        setCurrentPage(currentPage + 1)
        setHasMoreComment(has_more)
        setIsLoading(false)
      })
      .catch(e => {
        // no-op
      })
  }

  // 评论文章
  function handleCommentClick(commentText = '') {
    if (!commentText) {
      Toast.show({
        text: '评论内容不能为空！',
      })
      return Promise.reject(new Error('评论内容不能为空！'))
    }

    const params = {
      aid: 1839,
      app_name: appName,
      text: xss.filterXSS(commentText),
      group_id: gid,
      item_id: gid,
    }

    return fetch(
      getUrl(`/motor/proxy/comment/browser/2/data/v3/post_message/`),
      {
        method: 'POST',
        headers: {
          'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: serializeObject(params),
      }
    )
      .then(res => {
        const { errno, data = {} } = res
        if (errno !== 0) {
          Toast.show({
            text: '评论失败',
          })
          throw new Error(`评论失败! errorNo: ${errno}`)
        }

        Toast.show({
          text: '评论成功',
        })
        setDataList(
          [
            {
              comment: data,
            },
          ].concat(dataList)
        )
        if (updateTotalCount) {
          updateTotalCount(updated_total_count + 1)
        }

        setCommentCount(commentCount + 1)
      })
      .catch(e => {
        // no-op
      })
  }

  // 删除评论
  function handleDeleteComment(commentId = '', rank: number, replyId = '') {
    if (!commentId) {
      // 评论id为空
      return Promise.reject(new Error('评论id为空'))
    }

    const params = {
      aid,
      app_name: appName,
      id: commentId,
    }

    const address =
      replyId === ''
        ? '/motor/proxy/delete_comment/browser/2/comment/v1/delete_comment/'
        : '/motor/proxy/delete_reply/browser/2/comment/v1/delete_reply/'

    return fetch(
      getUrl(
        `${address}?${serializeObject(
          replyId !== '' ? { ...params, reply_id: replyId } : params
        )}`
      ),
      {
        headers: {
          'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
        },
      }
    )
      .then(data => {
        const { errno, message } = data || {}

        if (errno !== 0) {
          Toast.show({
            text: '删除评论失败！',
          })
          throw new Error(`删除评论失败 error = ${errno}, message = ${message}`)
        }
        Toast.show({
          text: '删除评论成功！',
        })

        if (!replyId) {
          dataList.splice(rank, 1)
          setDataList([...dataList])
          if (updateTotalCount) {
            updateTotalCount(updated_total_count - 1)
          }
          setCommentCount(commentCount - 1)
        }
      })
      .catch(e => {
        // no-op
      })
  }

  // 举报评论用户
  function handleReportUser(
    commentId: string,
    reportTypes: string,
    description = '',
    reportUserId?: number
  ) {
    const web_id = Cookies('tt_webid') || ''
    const formData = new FormData()
    formData.append('description', description)
    formData.append('comment_id', commentId)
    formData.append('source', '204')
    formData.append('report_types', reportTypes)
    formData.append('app_key', 'auto_web_pc-web')
    formData.append('aid', '1839')
    formData.append('app_name', 'auto_web_pc')
    formData.append(
      'device_id',
      typeof web_id === 'object' ? JSON.stringify(web_id) : web_id
    )
    if (userId) {
      formData.append('user_id', String(userId))
    }
    reportUserId && formData.append('report_user_id', String(reportUserId))
    fetch(getUrl('/api/feedback/v1/report_comment/'), {
      method: 'POST',
      body: formData,
    })
      .then(res => {
        const { err_code } = res

        if (err_code !== 0) {
          Toast.show({
            text: '举报失败',
          })
          return
        }

        Toast.show({
          text: '举报成功',
        })
      })
      .catch(e => {
        console.log(e)
      })
  }

  const handleClickViewMore = (e: SyntheticEvent) => {
    e.stopPropagation()
    if (!inheritNewCard) {
      e.preventDefault()
      loadComment()
    }
  }

  useEffect(() => {
    loadComment()
  }, [])

  return (
    <div className="container">
      <Header
        totalCount={commentCount}
        aid={aid}
        appName={appName}
        gid={gid}
        author_id={author_id}
        commentArticle={handleCommentClick}
        eventBus={EventBus}
        titleLeft={titleLeft}
      />
      {dataList.map((item, index) => {
        return (
          <Item
            key={`comment_${safeGet(item, 'comment.id_str') || index}`}
            rank={index}
            info={item}
            aid={aid}
            appName={appName}
            gid={gid}
            userId={userId}
            showUnderLine={index !== dataList.length - 1}
            deleteComment={handleDeleteComment}
            reportUser={handleReportUser}
            eventBus={EventBus}
          />
        )
      })}
      {isLoading ? (
        <Loading />
      ) : hasMoreComment ? (
        <a href={href} target={'_blank'}>
          <div className="show-more" onClick={handleClickViewMore}>
            查看更多评论
          </div>
        </a>
      ) : (
        <div className="load-all">已加载全部评论</div>
      )}
      <style jsx>
        {`
          .container {
            width: 100%;
            padding-bottom: 20px;
          }
          .show-more,
          .load-all {
            color: #1f2129;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
          }
          .show-more {
            cursor: pointer;
          }
          .show-more::after {
            content: '';
            width: 16px;
            height: ${inheritNewCard ? '16' : '8'}px;
            background-image: url('${
    inheritNewCard
      ? show_more_icon
      : 'https://sf3-ttcdn-tos.pstatp.com/img/motor-img/b6b3ea3ec0678b0a67c253830e2e775d~noop.png'
    }');
            background-size: 100% 100%;
          }
        `}
      </style>
    </div>
  )
}

export default Comment
